import React, { useState, memo } from 'react';
import { twMerge } from 'tailwind-merge';
import useAppContext from 'flow/hooks/useAppContext';

interface PinCodeProps {
    meetingCode: string;
    pinCode?: string;
    onClick: (meetingCode: string) => Promise<void>;
}

const PinCode = ({ meetingCode, pinCode, onClick }: PinCodeProps) => {
    const { i18next } = useAppContext();
    const [loadingPin, setLoadingPin] = useState<boolean>(false);

    if (pinCode) {
        return (
            <div className="callmodal-info" data-test-id="pin-code-displayed">
                {'#' + pinCode}
            </div>
        );
    }

    const requestPin = async () => {
        setLoadingPin(true);
        await onClick(meetingCode);
        setLoadingPin(false);
    };

    return (
        <button
            className={twMerge(
                'callmodal-info cursor-default border-none bg-transparent p-0 text-base',
                loadingPin
                    ? 'text-gray-500'
                    : 'font-bold text-gray-400 hover:opacity-80',
            )}
            onClick={requestPin}
            disabled={loadingPin}
            data-test-id="pin-code-clickable"
        >
            {i18next.t('videoconference.join_info.show_pin')}
        </button>
    );
};

export default memo(PinCode);
